export default __webpack_public_path__ + "static/media/howtouse_plus_03_ko.a83dc61f.png";